import classNames from "classnames";
import { FC, useEffect, useRef } from "react";
import * as React from "react";

import { KeyCodeEnum } from "constants/keyCode";

export interface ICannedResponsesDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
  className?: string;
  textareaWithCannedResponsesRef: React.RefObject<HTMLDivElement>;
}

export const CannedResponsesDropdown: FC<ICannedResponsesDropdownProps> = ({
  className,
  onClose,
  children,
  textareaWithCannedResponsesRef,
  ...restProps
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClickOutside = (e: MouseEvent) => {
    e.stopPropagation();
    if (dropdownRef.current && dropdownRef.current.contains(e.target as Node)) {
      return;
    }

    if (textareaWithCannedResponsesRef.current && textareaWithCannedResponsesRef.current.contains(e.target as Node)) {
      return;
    }

    onClose();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === KeyCodeEnum.Esc) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  return (
    <div
      {...restProps}
      data-testid="canned-responses-dropdown"
      ref={dropdownRef}
      className={classNames("lc-dropdown", "lc-dropdown--visible", className)}
    >
      {children}
    </div>
  );
};
